export const CONTACT_US_PRIMARY_LINKS = [
    {
        name: 'info@realmworkshop.co',
        url: 'mailto:info@realmworkshop.co',
        icon: {
            lib: 'fas',
            ico: 'envelope',
        },
    },
    {
        name: '@realmworkshop',
        url: 'https://www.instagram.com/realmworkshop',
        icon: {
            lib: 'fab',
            ico: 'instagram',
        },
    },
];

export const CONTACT_FORM_DETAILS = {
    type: 'contact-us-success',
    to: 'nicole@realmworkshop.co ',
};
